import * as React from "react";

import { useDispatch } from "@teamprevent/admin-redux";

import { loadBbvReportSuccessorTasks } from "../../../bbvReport/actions";

import { CloseTaskAndCreateFollowUpTaskModal } from "./CloseTaskAndCreateFollowUpTaskModal";

export const ActionBbvTaskModal = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadBbvReportSuccessorTasks());
    }, [dispatch]);

    return <CloseTaskAndCreateFollowUpTaskModal />;
};
